import {deserialize, deserializeAs} from 'cerialize';

export class Session {
  @deserialize id: string | undefined;
  @deserializeAs(Date) createdOn: Date | undefined;
  @deserializeAs(Date) expireOn: Date | undefined;
}
